module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-6.b4f1b723.png";